import { render, staticRenderFns } from "./SummaryDasarJati.vue?vue&type=template&id=9eb38292&"
import script from "./SummaryDasarJati.vue?vue&type=script&lang=js&"
export * from "./SummaryDasarJati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports